import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQs({ category, accent = "#00FFC2", title = "Frequently asked" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const url = category ? `/faqs?category=${category}` : "/faqs";
    http.get(url).then(({ data }) => setItems(data.items));
  }, [category]);

  if (!items.length) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="faqs-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
        <div className="lg:col-span-5">
          <div className="label-eyebrow mb-3">FAQ</div>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight font-display-media italic leading-tight">
            {title.split(" ").slice(0, -1).join(" ")}{" "}
            <span style={{ color: accent }}>{title.split(" ").slice(-1)[0]}.</span>
          </h2>
        </div>
        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full space-y-2">
            {items.map((f) => (
              <AccordionItem
                key={f.id}
                value={f.id}
                className="glass rounded-xl border-none px-5"
                data-testid={`faq-${f.id}`}
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold hover:no-underline py-5">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-gray-400 leading-relaxed pb-5">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
